import { render, staticRenderFns } from "./BoxQueueTrafficKPI.vue?vue&type=template&id=0a304ac6&"
import script from "./BoxQueueTrafficKPI.vue?vue&type=script&lang=js&"
export * from "./BoxQueueTrafficKPI.vue?vue&type=script&lang=js&"
import style0 from "./BoxQueueTrafficKPI.vue?vue&type=style&index=0&id=0a304ac6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInnerLoading,QSpinnerTail,QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInnerLoading,QSpinnerTail,QCard})
